export default __webpack_public_path__ + "static/media/69.b6e02e03.jpeg";